import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import ls from 'local-storage'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading vuex modules
 * -----------------------------------------------------------------------------------------------------------
 */
import account from '@/components/account/store'
import icon from '@/components/icon/store'
import agency from '@/components/agency/store'
import category from '@/components/category/store'
import message from '@/components/message/store'
import manager from '@/components/manager/store'
import examplePicture from '@/components/example-picture/store'
import project from '@/components/project/store'
import preview from '@/components/preview/store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    account,
    icon,
    agency,
    category,
    message,
    manager,
    examplePicture,
    project,
    preview
  },
  state: {
    loading: false,
    path: '',
    langs: [
      { value: 'en', text: 'English' },
      { value: 'fr', text: 'Français' },
      { value: 'es', text: 'Español' },
      { value: 'fi', text: 'Finnish' }
    ]
  },
  getters: {
    loading: (state) => state.loading,
    breadcrumb: (state) => state.breadcrumb,
    path: (state) => state.path,
    langs: (state) => state.langs
  },
  actions: {
    setLoading ({commit, dispatch}, loading) {
      commit('setLoading', loading)
    },
    setBreadcrumb ({commit, dispatch}, breadcrumb) {
      commit('setBreadcrumb', breadcrumb)
    },
    setPath ({commit, dispatch}, path) {
      commit('setPath', path)
    },
    toggleLoadding ({commit}, loading = true) {
      commit('setLoading', loading)
    },
    changeLanguage (value) {
      if (value) {
        ls.set('lang', value)
      }
    }
  },
  mutations: {
    setLoading (state, setLoading) {
      state.loading = setLoading
    },
    setBreadcrumb (state, setBreadcrumb) {
      state.breadcrumb = setBreadcrumb
    },
    setPath (state, path) {
      state.path = path
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js